var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section news-item"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("NEWS")]),_vm._v(" "),_c('div',{staticClass:"news-item__content"},[_c('pre',{staticClass:"text-sm"},[_vm._v(_vm._s(_vm.data))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }